export default "__VITE_ASSET__D8qMTdqb__"